import { render, staticRenderFns } from "./TemplateDialogEdit.vue?vue&type=template&id=4c9f30a4&scoped=true&"
import script from "./TemplateDialogEdit.vue?vue&type=script&lang=js&"
export * from "./TemplateDialogEdit.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDialogEdit.vue?vue&type=style&index=0&id=4c9f30a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9f30a4",
  null
  
)

export default component.exports